import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import { $gitDiffOrShow } from "../../internal/git";

/**
 * Hook to get either git diff or show data based on type
 * @param documentId - The document ID
 * @param type - Either "show" for a specific commit or "diff" for working directory changes
 * @param commitHash - The commit hash (required when type is "show")
 * @returns The git data, refresh function, and loading/error states
 */
export const useGitDiffOrShow = (
	documentId: string | undefined,
	type: "show" | "diff",
	commitHash?: string
) => {
	const diffOrShowAtom = $gitDiffOrShow({ documentId, type, refspec: commitHash });
	const diffOrShowLoadable = useAtomValue(loadable(diffOrShowAtom));
	const refresh = useSetAtom(diffOrShowAtom);

	return {
		data: diffOrShowLoadable.state === "hasData" ? diffOrShowLoadable.data : undefined,
		refresh,
		isLoading: diffOrShowLoadable.state === "loading",
		isError: diffOrShowLoadable.state === "hasError",
	};
};
